import Cookies from 'js-cookie';
import { TOKEN_NAME } from '../constants';

// Cached OS detection
let cachedOS = null;

// Utility function to detect OS, with caching
function getOS() {
  if (!cachedOS) {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/windows/i.test(userAgent)) {
      cachedOS = 'windows';
    } else if (/mac/i.test(userAgent)) {
      cachedOS = 'macos';
    } else if (/android/i.test(userAgent)) {
      cachedOS = 'android';
    } else if (/iphone|ipad|ipod/i.test(userAgent)) {
      cachedOS = 'ios';
    } else if (/linux/i.test(userAgent)) {
      cachedOS = 'linux';
    } else {
      cachedOS = 'other';
    }
  }
  return cachedOS;
}

// Utility function to send a user activity event to the backend
export function sendUserActivityEvent({ userId, eventType, pageUrl = null, elementId = null }) {
  // Product can be hardcoded
  const product = 'dashboard';

  // Construct the event payload
  const eventPayload = {
    user_id: userId,
    event_type: eventType,
    product: product,
    os_name: getOS(),
    page_url: pageUrl,
    element_id: elementId,
  };

  // Construct the DTO for sending to the backend
  const eventApiDto = {
    name: 'sparqle.user_activity',
    payload: eventPayload,
  };
  try {
    fetch(`${process.env.REACT_APP_API_URI}/event-proxy/track-event`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${Cookies.get(TOKEN_NAME)}`,
      },
      body: JSON.stringify(eventApiDto),
    });
  } catch (e) {
    console.error('Failing to log events...');
  }
  // Send the event via backend proxy
}
